"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timezoneAliases = exports.timezones = void 0;
exports.timezones = {
    "Etc/GMT+12": "International Date Line West",
    "Pacific/Midway": "Midway Island, Samoa",
    "Pacific/Honolulu": "Hawaii",
    "America/Juneau": "Alaska",
    "America/Dawson": "Pacific Time (US and Canada); Tijuana",
    "America/Boise": "Mountain Time (US and Canada)",
    "America/Chihuahua": "Chihuahua, La Paz, Mazatlan",
    "America/Phoenix": "Arizona",
    "America/Chicago": "Central Time (US and Canada)",
    "America/Regina": "Saskatchewan",
    "America/Mexico_City": "Guadalajara, Mexico City, Monterrey",
    "America/Belize": "Central America",
    "America/Detroit": "Eastern Time (US and Canada)",
    "America/Indiana/Indianapolis": "Indiana (East)",
    "America/Bogota": "Bogota, Lima, Quito",
    "America/Glace_Bay": "Atlantic Time (Canada)",
    "America/Caracas": "Caracas, La Paz",
    "America/Santiago": "Santiago",
    "America/St_Johns": "Newfoundland and Labrador",
    "America/Sao_Paulo": "Brasilia",
    "America/Argentina/Buenos_Aires": "Buenos Aires, Georgetown",
    "America/Godthab": "Greenland",
    "Etc/GMT+2": "Mid-Atlantic",
    "Atlantic/Azores": "Azores",
    "Atlantic/Cape_Verde": "Cape Verde Islands",
    GMT: "GMT",
    "Africa/Casablanca": "Casablanca, Monrovia",
    "Atlantic/Canary": "Canary Islands",
    "Europe/London": "Dublin, Edinburgh, Lisbon, London",
    "Europe/Belgrade": "Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    "Europe/Sarajevo": "Sarajevo, Skopje, Warsaw, Zagreb",
    "Europe/Brussels": "Brussels, Copenhagen, Madrid, Paris",
    "Europe/Amsterdam": "Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    "Africa/Algiers": "West Central Africa",
    "Europe/Bucharest": "Bucharest",
    "Africa/Cairo": "Cairo",
    "Europe/Helsinki": "Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius",
    "Europe/Athens": "Athens, Istanbul, Minsk",
    "Asia/Jerusalem": "Jerusalem",
    "Africa/Harare": "Harare, Pretoria",
    "Europe/Moscow": "Moscow, St. Petersburg, Volgograd",
    "Asia/Kuwait": "Kuwait, Riyadh",
    "Africa/Nairobi": "Nairobi",
    "Asia/Baghdad": "Baghdad",
    "Asia/Tehran": "Tehran",
    "Asia/Dubai": "Abu Dhabi, Muscat",
    "Asia/Baku": "Baku, Tbilisi, Yerevan",
    "Asia/Kabul": "Kabul",
    "Asia/Yekaterinburg": "Ekaterinburg",
    "Asia/Karachi": "Islamabad, Karachi, Tashkent",
    "Asia/Kolkata": "Chennai, Kolkata, Mumbai, New Delhi",
    "Asia/Kathmandu": "Kathmandu",
    "Asia/Dhaka": "Astana, Dhaka",
    "Asia/Colombo": "Sri Jayawardenepura",
    "Asia/Almaty": "Almaty, Novosibirsk",
    "Asia/Rangoon": "Yangon Rangoon",
    "Asia/Bangkok": "Bangkok, Hanoi, Jakarta",
    "Asia/Krasnoyarsk": "Krasnoyarsk",
    "Asia/Shanghai": "Beijing, Chongqing, Hong Kong SAR, Urumqi",
    "Asia/Kuala_Lumpur": "Kuala Lumpur, Singapore",
    "Asia/Taipei": "Taipei",
    "Australia/Perth": "Perth",
    "Asia/Irkutsk": "Irkutsk, Ulaanbaatar",
    "Asia/Seoul": "Seoul",
    "Asia/Tokyo": "Osaka, Sapporo, Tokyo",
    "Asia/Yakutsk": "Yakutsk",
    "Australia/Darwin": "Darwin",
    "Australia/Adelaide": "Adelaide",
    "Australia/Sydney": "Canberra, Melbourne, Sydney",
    "Australia/Brisbane": "Brisbane",
    "Australia/Hobart": "Hobart",
    "Asia/Vladivostok": "Vladivostok",
    "Pacific/Guam": "Guam, Port Moresby",
    "Asia/Magadan": "Magadan, Solomon Islands, New Caledonia",
    "Pacific/Fiji": "Fiji Islands, Kamchatka, Marshall Islands",
    "Pacific/Auckland": "Auckland, Wellington",
    "Pacific/Tongatapu": "Nuku'alofa",
};
exports.timezoneAliases = {
    "America/Barbados": "America/Caracas",
    "America/Denver": "America/Belize",
    "America/Los_Angeles": "America/Dawson",
    "America/New_York": "America/Detroit",
    "America/Toronto": "America/Detroit",
    "America/Vancouver": "America/Dawson",
    "Asia/Riyadh": "Asia/Kuwait",
    "Asia/Qatar": "Asia/Kuwait",
    "Australia/Canberra": "Australia/Sydney",
    "Australia/Melbourne": "Australia/Sydney",
    "Australia/Queensland": "Australia/Brisbane",
    "Canada/Eastern": "America/Detroit",
    "Canada/Pacific": "America/Dawson",
    "Etc/GMT+1": "Atlantic/Cape_Verde",
    "Etc/GMT-5": "Asia/Karachi",
    "Europe/Belfast": "Europe/London",
    "Europe/Berlin": "Europe/Amsterdam",
    "Europe/Paris": "Europe/Brussels",
    "Europe/Warsaw": "Europe/Sarajevo",
    "Europe/Zurich": "Europe/Amsterdam",
    Japan: "Asia/Tokyo",
    Universal: "GMT",
    "US/Arizona": "America/Phoenix",
    "US/Central": "America/Chicago",
    "US/Eastern": "America/Detroit",
    "US/Hawaii": "Pacific/Honolulu",
    "US/Mountain": "America/Boise",
    "US/Pacific": "America/Dawson",
    UTC: "GMT",
    "Pacific/Wallis": "Pacific/Fiji",
    "Africa/Asmara": "Africa/Nairobi",
    "America/Aruba": "America/Caracas",
    Hongkong: "Asia/Shanghai",
    Poland: "Europe/Sarajevo",
    "Africa/Abidjan": "GMT",
    "Africa/Accra": "GMT",
    "Africa/Addis_Ababa": "Africa/Nairobi",
    "Africa/Asmera": "Africa/Nairobi",
    "Africa/Bamako": "GMT",
    "Africa/El_Aaiun": "Africa/Casablanca",
    "Africa/Juba": "Africa/Nairobi",
    "Africa/Lusaka": "Africa/Harare",
    "Africa/Malabo": "Africa/Algiers",
    "Africa/Monrovia": "GMT",
    "Africa/Ouagadougou": "GMT",
    "America/Anchorage": "America/Juneau",
    "America/Anguilla": "America/Caracas",
    "America/Argentina/ComodRivadavia": "America/Argentina/Buenos_Aires",
    "America/Argentina/Rio_Gallegos": "America/Argentina/Buenos_Aires",
    "America/Argentina/San_Juan": "America/Argentina/Buenos_Aires",
    "America/Argentina/San_Luis": "America/Argentina/Buenos_Aires",
    "America/Blanc-Sablon": "America/Caracas",
    "America/Catamarca": "America/Argentina/Buenos_Aires",
    "America/Costa_Rica": "America/Belize",
    "America/Dominica": "America/Caracas",
    "America/Eirunepe": "America/Bogota",
    "America/Knox_IN": "America/Chicago",
    "America/Lima": "America/Bogota",
    "America/Matamoros": "America/Chicago",
    "America/Mendoza": "America/Argentina/Buenos_Aires",
    "America/Moncton": "America/Glace_Bay",
    "America/St_Thomas": "America/Caracas",
    "America/Tegucigalpa": "America/Belize",
    "America/Tortola": "America/Caracas",
    "America/Virgin": "America/Caracas",
    "Asia/Bishkek": "Asia/Almaty",
    "Asia/Chita": "Asia/Yakutsk",
    "Asia/Ho_Chi_Minh": "Asia/Bangkok",
    "Europe/Rome": "Europe/Amsterdam",
    "Europe/Vienna": "Europe/Amsterdam",
};
//# sourceMappingURL=timezones.js.map